import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { SEGMENT_CONFIG } from 'v2/common/constants/index';
import { getSelectorBasedStoreValue } from '../../redux/selector';
import { setPartialQuantConfig } from '../../redux/actions';
import { onChangeGlobalSegment } from '../../events/globalSegment';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { isCrypto } = ApplicationDomainUtility;

const GlobalSegmentSelector = () => {
  const uiConfigs = useSelector((state) => getSelectorBasedStoreValue(state, 'quantConfig.uiConfigs'));
  const { segment } = uiConfigs;
  const dispatch = useDispatch();
  const pipeConfigs = useSelector((state) => getSelectorBasedStoreValue(state, 'quantConfig.pipeConfigs'));

  const segmentOptions = [
    { value: SEGMENT_CONFIG.equity, label: 'Equity & Index', isShowLabel: !isCrypto },
    { value: SEGMENT_CONFIG.future, label: isCrypto ? 'Future' : 'Future & Options', isShowLabel: true },
  ];
  return (
    <select
      className="segment-selector form-control"
      value={segment}
      onChange={(event) => {
        const newUiConfigs = {
          ...uiConfigs,
          segment: event.target.value
        };

        dispatch(
          setPartialQuantConfig(
            onChangeGlobalSegment({
              pipeConfigs,
              uiConfigs: newUiConfigs
            })
          )
        );
      }}
    >
      {_.map(segmentOptions, (op) => {
        if (!op.isShowLabel) return null;

        return <option value={op.value} key={op.value}>{op.label}</option>;
      })}
    </select>
  );
};

GlobalSegmentSelector.propTypes = {};

export default GlobalSegmentSelector;
